import React, { useEffect, useState } from "react";
import { Download, Share } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const InstallButton = ({ variant = "outline", className = "", label = "Install app", always = false, size = "sm", showLogo = false }) => {
  const [deferred, setDeferred] = useState(null);
  const [canPrompt, setCanPrompt] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setCanPrompt(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const onInstalled = () => { setCanPrompt(false); toast.success("TradieDesk installed 🎉"); };
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (isStandalone()) return null;
  if (!always && !canPrompt && !isIos()) return null;

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome === "accepted") setCanPrompt(false);
      setDeferred(null);
      return;
    }
    if (isIos()) {
      toast("Tap the Share icon, then \"Add to Home Screen\"", { icon: <Share className="h-4 w-4" />, duration: 6000 });
      return;
    }
    toast("To install: click the install icon in your browser's address bar, or open the browser menu → \"Install app\".", { duration: 7000 });
  };

  return (
    <Button data-testid="install-app-btn" onClick={install} variant={variant} size={size} className={`rounded-sm gap-2 ${className}`}>
      {showLogo ? <img src="/icon-192.png" alt="" className="h-5 w-5 rounded-[3px]" /> : <Download className="h-4 w-4" />} {label}
    </Button>
  );
};
